import React, { useState, useEffect } from "react";
import { InfoBlock } from "./styled";
import { useHistory } from "react-router";
import Button from "../design_components/Button/Button";
import { Container, Heading, Text } from "../../styled";
import {
  createEventObjectFunction,
  fadeInFunction,
  fadeOutFunction,
} from "../../utils/helper";
import { onboardingFillEventAmplitude } from "../../amplitude/events";
import { onboardingFillEvent } from "../../firebaseAnalytics/events";
import { analytics } from "../../firebaseAnalytics";
import ReactPixel from "react-facebook-pixel";
import AudioPlayer from "../design_components/Audio/Audio";
import { greyTextColor } from "../../constants/colors";

const Info = ({
  data,
  answers,
  route,
  pixelObject,
  audioValues,
  remoteConfig,
  landingId,
}) => {
  const history = useHistory();
  const [titleIndex, setTitleIndex] = useState(0);
  const [isDynamic, setIsDynamic] = useState(null);

  const [audioPlayed, setAudioPlayed] = useState(false);
  const [currentPlayerIndex, setCurrentPlayerIndex] = useState(null);

  useEffect(() => {
    fadeInFunction();
    if (route === "/onboarding/SleepAndActivityD2") {
      setIsDynamic(true);
      let result = 0;
      data.dependKeys.map((key) => {
        result = result + answers[key][0];
      });
      result > 2 && setTitleIndex(1);
    } else {
      setIsDynamic(false);
    }
  }, [data]);

  const handleButtonClick = () => {
    if (data.pixelEvent) {
      ReactPixel.trackCustom(data.pixelEvent, pixelObject);
    }
    fadeOutFunction();
    const eventObj = createEventObjectFunction(
      data.eventFillName,
      null,
      landingId
    );
    if (data.audioArray && data.audioArray.length) {
      if (remoteConfig[data.remoteConfigKeyDepending] === false) {
        eventObj[data.audioEventFillName] = "no_content";
      } else {
        eventObj[data.audioEventFillName] = audioPlayed;
      }
    }
    // Событие №4 fill
    onboardingFillEvent(analytics, eventObj);
    onboardingFillEventAmplitude(eventObj);
    setTimeout(() => {
      history.push(data.nextRoute);
    }, 500);
  };

  const setText = () => {
    if (isDynamic) {
      return data.text[titleIndex];
    }
    if (data.dependOn && data.text) {
      return data.text[answers[data.dependOn.title][0]];
    }
    if (data.dependOn && data.textHtml) {
      return data.textHtml[answers[data.dependOn.title][0]];
    }
    if (
      data.remoteConfigKeyDepending &&
      remoteConfig[data.remoteConfigKeyDepending] === false &&
      data.textRemoteFalse
    ) {
      return data.textRemoteFalse;
    } else {
      return data.text;
    }
  };

  const setTitle = () => {
    if (isDynamic) {
      return data.title[titleIndex];
    }
    if (Array.isArray(data.title) && isDynamic !== null) {
      return data.title[answers[data.dependOn.title][0]] || data.title[0];
    }
    if (
      data.remoteConfigKeyDepending &&
      remoteConfig[data.remoteConfigKeyDepending] === false &&
      data.titleRemoteFalse
    ) {
      return data.titleRemoteFalse;
    } else {
      return data.title;
    }
  };

  const audioBlockRender = () => {
    return (
      <InfoBlock.Top.Audio>
        {!data.audioDepend ? (
          <Text.Second
            style={{
              textAlign: "left",
              color: greyTextColor,
              marginBottom: 40,
            }}
          >
            Preview one of our most popular Journey sleep stories below for
            free.
          </Text.Second>
        ) : null}
        <div style={{ marginBottom: 40 }}>
          {!data.audioDepend
            ? data.audioArray.map((audio, i) => {
                return (
                  <AudioPlayer
                    src={audio.src}
                    previewImage={audio.img}
                    title={audio.title}
                    name={audio.name}
                    key={`audio-${audio.id}`}
                    setAudioPlayed={setAudioPlayed}
                    audioPlayed={audioPlayed}
                    style={{ marginBottom: 15 }}
                    currentPlayerIndex={currentPlayerIndex}
                    setCurrentPlayerIndex={setCurrentPlayerIndex}
                    index={i}
                    audioEventFillName={data.audioEventFillName}
                    landingId={landingId}
                  />
                );
              })
            : audioValues.map((index, i) => {
                return (
                  <AudioPlayer
                    src={data.audioArray[index].src}
                    previewImage={data.audioArray[index].img}
                    title={data.audioArray[index].title}
                    name={data.audioArray[index].name}
                    key={`audio-${data.audioArray[index].id}`}
                    setAudioPlayed={setAudioPlayed}
                    audioPlayed={audioPlayed}
                    style={{ marginBottom: 15 }}
                    currentPlayerIndex={currentPlayerIndex}
                    setCurrentPlayerIndex={setCurrentPlayerIndex}
                    index={i}
                    audioEventFillName={data.audioEventFillName}
                    fillName={data.eventFillName}
                  />
                );
              })}
        </div>
      </InfoBlock.Top.Audio>
    );
  };

  const previewIconsRender = () => {
    return (
      <div className="icons-wrapper">
        <div className="icons-first">
          <img src={data.audioArray[audioValues[0]].img} alt="preview" />
        </div>
        <div className="icons-second">
          <img src={data.audioArray[audioValues[1]].img} alt="preview" />
        </div>
        <div className="icons-third">
          <img src={data.audioArray[audioValues[2]].img} alt="preview" />
        </div>
        <div className="icons-fourth">
          <img src={data.audioArray[audioValues[3]].img} alt="preview" />
        </div>
      </div>
    );
  };

  return (
    <InfoBlock>
      <Container.Content>
        <InfoBlock.Wrapper className={"animated"}>
          <InfoBlock.Top>
            <InfoBlock.Top.Title>
              <Heading.Third>{setTitle()}</Heading.Third>
            </InfoBlock.Top.Title>
            {data.text && (
              <InfoBlock.Top.Text>
                <Text.Second>{setText()}</Text.Second>
              </InfoBlock.Top.Text>
            )}
            {data.textHtml && (
              <InfoBlock.Top.Text>
                <Text.Second dangerouslySetInnerHTML={setText()} />
              </InfoBlock.Top.Text>
            )}
            {data.texts &&
              data.texts.map((text, index) => {
                return (
                  <InfoBlock.Top.Text key={index}>
                    <Text.Second>{text}</Text.Second>
                  </InfoBlock.Top.Text>
                );
              })}
            {data.text2 && (
              <InfoBlock.Top.Text>
                <Text.Second>{data.text2}</Text.Second>
              </InfoBlock.Top.Text>
            )}
            {data.audioArray &&
            data.audioArray.length &&
            data.remoteConfigKeyDepending &&
            remoteConfig[data.remoteConfigKeyDepending]
              ? audioBlockRender()
              : route === "/onboarding/PersonalizationNarrative"
              ? previewIconsRender()
              : null}
          </InfoBlock.Top>
          <InfoBlock.Bottom>
            <Button
              type={"default"}
              isGradient={true}
              text={data.buttonText ? data.buttonText : "Next"}
              action={handleButtonClick}
            />
          </InfoBlock.Bottom>
        </InfoBlock.Wrapper>
      </Container.Content>
    </InfoBlock>
  );
};

export default Info;
